import * as React from "react";
import { cn } from "@/lib/utils";

// Functional Skills English level tier, coloured by tier (Entry → cool navy,
// Level → warm red). Both ramps darken with the numeric level so E3 reads a
// touch stronger than E1, L2 stronger than L1. Tokens defined in globals.css.

const TIER: Record<string, string> = {
  E1: "bg-[hsl(var(--tier-entry)/0.5)] text-[hsl(var(--tier-entry-fg))] border-[hsl(var(--tier-entry-fg)/0.2)]",
  E2: "bg-[hsl(var(--tier-entry)/0.75)] text-[hsl(var(--tier-entry-fg))] border-[hsl(var(--tier-entry-fg)/0.25)]",
  E3: "bg-[hsl(var(--tier-entry))] text-[hsl(var(--tier-entry-fg))] border-[hsl(var(--tier-entry-fg)/0.3)]",
  L1: "bg-[hsl(var(--tier-level)/0.65)] text-[hsl(var(--tier-level-fg))] border-[hsl(var(--tier-level-fg)/0.2)]",
  L2: "bg-[hsl(var(--tier-level))] text-[hsl(var(--tier-level-fg))] border-[hsl(var(--tier-level-fg)/0.3)]",
  // HEDA diagnostic tier — amber-tinted so it's visually distinct from the
  // navy/green FS English palette.
  D1: "bg-[hsl(var(--tier-diagnostic)/0.55)] text-[hsl(var(--tier-diagnostic-fg))] border-[hsl(var(--tier-diagnostic-fg)/0.2)]",
  D2: "bg-[hsl(var(--tier-diagnostic)/0.8)] text-[hsl(var(--tier-diagnostic-fg))] border-[hsl(var(--tier-diagnostic-fg)/0.25)]",
  D3: "bg-[hsl(var(--tier-diagnostic))] text-[hsl(var(--tier-diagnostic-fg))] border-[hsl(var(--tier-diagnostic-fg)/0.3)]",
};

export interface LevelBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  code: string;
  size?: "sm" | "md";
}

export function LevelBadge({ code, size = "md", className, ...props }: LevelBadgeProps) {
  const tone = TIER[code] ?? "bg-muted text-muted-foreground border-transparent";
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md border font-semibold tabular-nums",
        size === "sm" ? "px-1.5 py-0 text-[10px]" : "px-2 py-0.5 text-xs",
        tone,
        className,
      )}
      {...props}
    >
      {code}
    </span>
  );
}
